
import e1 from '../Assets/event1.webp';
import e2 from '../Assets/event2.webp';
import e3 from '../Assets/event3.webp';
import e4 from '../Assets/event4.webp';

import p1 from '../Assets/trip1.webp';
import p2 from '../Assets/trip2.webp';
import p3 from '../Assets/trip3.webp';
import p4 from '../Assets/trip4.webp';

import h1 from '../Assets/hall1.webp';
import h2 from '../Assets/hall2.webp';
import h3 from '../Assets/hall3.webp';
import h4 from '../Assets/hall4.webp';

const hallitems = [
    {
        src: h1,
        key: 'hall-1',
        altText: 'Slide 1',
        caption: ''
    },
    {
        src: h2,
        caption: '',
        key: 'hall-2',
        altText: 'Slide 2'
    },
    {
        src: h3,
        caption: '',
        key: 'hall-3',
        altText: 'Slide 3'
    },
    {
        src: h4,
        caption: '',
        key: 'hall-4',
        altText: 'Slide 4'
    }
];

const eventitems = [
    {
        src: e1,
        caption: '',
        key: 'event-1',
        altText: 'Slide 1'
    },
    {
        src: e2,
        key: 'event-2',
        caption: '',
        altText: 'Slide 2'
    },
    {
        src: e3,
        key: 'event-3',
        caption: '',
        altText: 'Slide 3'
    },
    {
        src: e4,
        key: 'event-4',
        caption: '',
        altText: 'Slide 4'
    }
];

const tripitems = [
    {
        src: p1,
        key: 'trip-1',
        caption: '',
        altText: 'Slide 1'
    },
    {
        src: p2,
        key: 'trip-2',
        caption: '',
        altText: 'Slide 2'
    },
    {
        src: p3,
        key: 'trip-3',
        caption: '',
        altText: 'Slide 3'
    },
    {
        src: p4,
        caption: '',
        key: 'trip-4',
        altText: 'Slide 4'
    }
];

export { eventitems, tripitems, hallitems };